<template>
    <div class="input-wrapper">
        <input
            ref="input"
            :id="inputId"
            :value="value"
            :class="{
                'input-error': hasError && !isFocus,
                'disabled': disabled,
            }"
            :type="type"
            :disabled="disabled"
            @input="handleInputChange"
            @focus="handleFocus"
            @blur="handleBlur"
        />
        <label
            v-if="label"
            :for="inputId"
            :class="{
        'focused': isFocus || value,
        'disabled': disabled
      }"
        >
            {{ label }}
        </label>
        <span v-if="hasError && !isFocus" class="error-icon">
      <img :src="require('@/assets/exclamation.svg')" alt="alert">
    </span>
        <span v-if="hasError" class="error-text">
        {{ errorText }}
    </span>
    </div>
</template>

<script>
import IMask from 'imask';

export default {
    name: 'SystemInput',
    props: {
        value: {
            type: [String, Number],
        },
        label: {
            type: String,
        },
        error: {
            type: String,
        },
        type: {
            type: String,
            default: 'text',
        },
        disabled: {
            type: Boolean,
        },
        mask: {
            type: [String, Object],
            default: null,
        },
        validate: {
            type: Function,
            default: null
        }
    },
    computed: {
        errorText() {
            return this.error || 'Поле пустое или некорректно заполнено';
        }
    },
    data() {
        return {
            inputId: `system-input-${Math.random().toString(36).substr(2, 9)}`,
            isFocus: false,
            hasError: false,
            maskRef: null,
        };
    },
    watch: {
        value(newVal) {
            if (this.maskRef && this.maskRef.value !== newVal) {
                this.maskRef.value = newVal;
            }
        }
    },
    mounted() {
        if (this.mask) {
            this.initMask();
        }
    },
    beforeDestroy() {
        this.destroyMask();
    },
    methods: {
        initMask() {
            this.maskRef = IMask(this.$refs.input, {
                ...(typeof this.mask === 'string' ? {mask: this.mask} : this.mask),
                lazy: true, // стартовое поведение
            });
            this.maskRef.on('accept', () => {
                this.$emit('input', this.maskRef.value);
                this.hasError = !this.maskRef.value.trim();
            });
        },
        destroyMask() {
            if (this.maskRef) {
                this.maskRef.destroy();
                this.maskRef = null;
            }
        },
        handleInputChange(event) {
            if (!this.maskRef) {
                this.$emit('input', event.target.value);
                this.hasError = !event.target.value.trim();
            }
        },
        handleFocus() {
            this.isFocus = true;
            if (this.maskRef) {
                this.maskRef.updateOptions({lazy: false});
            }
        },
        handleBlur() {
            this.isFocus = false;
            if (this.maskRef) {
                this.maskRef.updateOptions({lazy: true});
            }
            this.isValid();
        },
        isValid() {
            const value = this.value?.trim();

            if (!value) {
                this.hasError = true;
                return;
            }

            if (typeof this.validate === 'function') {
                this.hasError = !this.validate(value);
            } else {
                this.hasError = false;
            }
        }
    }
}
</script>
<style scoped>
.input-wrapper {
    position: relative;
    width: 100%;
    height: fit-content;
}

.input-wrapper input {
    width: 100%;
    height: 60px;
    border: 1px solid #b9bdc4;
    border-radius: 6px;
    background-color: #fff;
    padding: 32px 50px 11px 14px;
    transition: 350ms cubic-bezier(0.4, 0, 0.2, 1);
    min-width: 90px;
    outline: none;
}

.input-wrapper input:hover {
    border-color: #1f2229
}

.input-wrapper input.input-error {
    border-color: #d72f4b;
}

.input-wrapper input.disabled {
    border-color: #d1d8d6;
    color: rgba(143, 147, 153, 0.5);
}

.input-wrapper label {
    position: absolute;
    top: 20px;
    left: 14px;
    color: #65707b;
    cursor: text;
    transition: transform 0.3s ease-in-out;
}

.input-wrapper label.focused {
    top: 7px;
    transform: scale(0.8) translate(-12.5%, 0);
}

.input-wrapper label.disabled {
    color: rgba(143, 147, 153, 0.5);
}

.error-text {
    display: block;
    padding: 3px 0 2px;
    overflow: initial;
    color: #d72f4b;
    margin: 7px 4px 0 16px;
    font-size: 14px;
    line-height: 1.28;
    z-index: 1;
    width: auto;
}

.error-icon {
    position: absolute;
    top: 18px;
    right: 12px;
    display: inline-block;
    width: 26px;
    height: 26px;
}

</style>
